import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  MenuItem,
  Checkbox,
  ListItemText,
  Popover,
  Paper,
  MenuList,
  Icon,
} from '@material-ui/core';
import { APPLICATION_VARIANTS } from '../../constants';
import config from '../../config/config';
import styles from './AttributesMenu.module.css';
import defaultStyles from './AttributesMenu.module.css';
import jlrStyles from './AttributesMenuJlr.module.css';
import Erase from '../../icons/eraser.svg';
import greenErase from '../../icons/green-eraser.svg';
import { usePlantAndLinesStore } from '../../providers/PlantAndLinesStore/PlantAndLinesStore';
import { setStylesAccordingToPlant } from '../../utils/utils';
import { JLR_PLANT } from '../../constants';

const AttributesMenu = ({
  open,
  anchorEl,
  handleClose,
  columns,
  handleApply,
  selectedOptionalCols: selectedCols,
}) => {
  const [plant] = usePlantAndLinesStore().plantState;
  const [styles, setStyles] = useState(defaultStyles);
  const toggleColSelection = column => () => {
    if (!selectedCols.includes(column)) {
      return handleApply([...selectedCols, column]);
    }
    const index = selectedCols.indexOf(column);
    selectedCols.splice(index, 1);
    return handleApply([...selectedCols]);
  };

  useEffect(() => {
    setStylesAccordingToPlant(plant, setStyles, defaultStyles, jlrStyles);
  }, [plant]);

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
    >
      <Paper className={styles.menu}>
        <MenuList autoFocusItem={open}>
          <span className={styles.menuTitle}>
            Attributes
            <Button
              className={styles.menuButton}
              variant="contained"
              onClick={() => handleApply([])}
            >
              {' '}
              <Icon className={styles.eraseIcon}>
                <img
                  src={plant.label === JLR_PLANT ? greenErase : Erase}
                  alt="Clear All"
                  className={styles.eraseIcon}
                />
              </Icon>
              Clear all
            </Button>
          </span>
          <div
            className={
              config?.APPLICATION_VARIANT === APPLICATION_VARIANTS.IPMS4
                ? styles.menuInner
                : styles.menuInnerForPV
            }
          >
            {columns.map(column => (
              <MenuItem className={styles.menuItem} key={column} value={column}>
                <Checkbox
                  className={styles.checkBox}
                  color="default"
                  checked={selectedCols?.includes(column)}
                  onChange={toggleColSelection(column)}
                  inputProps={{ 'aria-label': `Checkbox ${column}` }}
                />
                <ListItemText>
                  <span className={styles.listItem}>{column}</span>
                </ListItemText>
              </MenuItem>
            ))}
          </div>
        </MenuList>
      </Paper>
    </Popover>
  );
};

AttributesMenu.propTypes = {
  open: PropTypes.bool.isRequired,
  columns: PropTypes.arrayOf(PropTypes.string).isRequired,
  anchorEl: PropTypes.instanceOf(Element),
  handleApply: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  selectedOptionalCols: PropTypes.array.isRequired,
};

export default AttributesMenu;
